import React, { createContext, useState } from 'react';

import type { Receipt } from 'client/graphql/types/generated';

export type ReceiptListContext = {
  receiptList: Receipt[];
  setReceiptList: React.Dispatch<React.SetStateAction<Receipt[]>>;
};

const defaultValue: ReceiptListContext = {
  receiptList: [],
  setReceiptList: () => {},
};

/**
 * 検索で取得した検収一覧を管理する
 */
export const ReceiptListContext = createContext(defaultValue);

export const ReceiptListProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [receiptList, setReceiptList] = useState<Receipt[]>([]);

  return (
    <ReceiptListContext.Provider
      value={{
        receiptList,
        setReceiptList,
      }}
    >
      {children}
    </ReceiptListContext.Provider>
  );
};
